export function useLocaleLink(
  options: Parameters<ReturnType<typeof useLocaleRoute>>[0],
  locale?: string
) {
  const localeRoute = useLocaleRoute()

  return localeRoute(options, locale)
}
